<template>
  <div id="barcodeReader">
    <section class="sectionReder">
      <v-quagga :onDetected="logIt" :readerTypes="['code_39_reader']"></v-quagga>
    </section>
  </div>
</template>

<script>
import Vue from "vue";
import VueQuagga from "vue-quaggajs";
Vue.use(VueQuagga);

export default {
  name: "barcodeReader",
  computed: {
    valueProp: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("update:value", val);
      }
    }
  },
  methods: {
    logIt(data) {
      this.valueProp = data.codeResult.code;
    }
  }
};
</script>

<style>
.sectionReder {
  width: 100%;
}

@media (min-width: 991.98px) {
  .sectionReder {
    height: 480px;
  }
}

@media (max-width: 991.98px) {
  .sectionReder {
    height: 200px;
  }
}

video {
  max-width: 100%;
}

canvas {
  max-width: 100%;
}
</style>
